export default __webpack_public_path__ + "static/media/call.03922b7a.png";